import React, { useState } from 'react';
import { investmentAdvisoryApi, AllocationProfileInput } from '../services/investmentAdvisoryApi.ts';
import { useConnectivityStatus } from '../hooks/useConnectivityStatus.ts';
import './InvestmentAllocation.css';

const InvestmentAllocationPage: React.FC = () => {
  const [form, setForm] = useState({
    risk_profile: '',
    asset_classes: '',
    target_allocations: '{"Ações": 60, "Renda Fixa": 40}',
    current_allocations: '{"Ações": 55, "Renda Fixa": 45}',
    last_reviewed_date: '',
  });
  const [alerts, setAlerts] = useState<string[]>([]);
  const [error, setError] = useState<string>('');
  const [saving, setSaving] = useState(false);
  const { isOnline, isBackendOnline } = useConnectivityStatus();
  const backendAvailable = isOnline && isBackendOnline;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const payload: AllocationProfileInput = {
        risk_profile: form.risk_profile,
        asset_classes: form.asset_classes.split(',').map((item) => item.trim()).filter(Boolean),
        target_allocations: JSON.parse(form.target_allocations),
        current_allocations: JSON.parse(form.current_allocations),
        last_reviewed_date: form.last_reviewed_date || undefined,
      };
      const response = await investmentAdvisoryApi.upsertAllocation(payload);
      setAlerts(response.data.rebalancing_alerts || []);
    } catch (err: any) {
      setError('Verifique os campos de alocação (JSON válido).');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="investment-allocation module-name">
      <div className="page-header">
        <div>
          <h1>Alocação de Ativos</h1>
          <p>Defina metas de alocação e receba alertas de rebalanceamento.</p>
        </div>
      </div>

      <div className="module-content">
        {!backendAvailable && (
          <div className="message error" style={{ marginBottom: '16px' }}>
            ⚠️ Alertas de rebalanceamento exigem conexão com o backend. Cadastro local continua disponível.
          </div>
        )}
        <form className="form-container allocation-form" onSubmit={handleSubmit}>
          <h3>Perfil e alocação</h3>
          <div className="form-group">
            <label>Perfil de risco</label>
            <input
              type="text"
              value={form.risk_profile}
              onChange={(e) => setForm({ ...form, risk_profile: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Classes de ativos (separadas por vírgula)</label>
            <input
              type="text"
              value={form.asset_classes}
              onChange={(e) => setForm({ ...form, asset_classes: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Alocação alvo (JSON)</label>
            <textarea
              value={form.target_allocations}
              onChange={(e) => setForm({ ...form, target_allocations: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Alocação atual (JSON)</label>
            <textarea
              value={form.current_allocations}
              onChange={(e) => setForm({ ...form, current_allocations: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Data de revisão</label>
            <input
              type="date"
              value={form.last_reviewed_date}
              onChange={(e) => setForm({ ...form, last_reviewed_date: e.target.value })}
            />
          </div>
          {error && <div className="allocation-error">{error}</div>}
          <div className="form-actions">
            <button className="primary-button" type="submit" disabled={saving}>{saving ? 'Salvando...' : 'Salvar alocação'}</button>
          </div>
        </form>

        {alerts.length > 0 && (
          <div className="allocation-alerts">
            <strong>Alertas de rebalanceamento:</strong>
            <ul>
              {alerts.map((alert) => (
                <li key={alert}>{alert}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestmentAllocationPage;
